<template>
  <div v-if="visible" class="force-change-password-modal-overlay">
    <el-dialog
      title="强制修改密码"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="500px"
      center
    >
      <el-alert
        :title="alertTitle"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;"
      />
      
      <el-form ref="form" :model="user" :rules="rules" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="user.oldPassword" placeholder="请输入旧密码" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="user.newPassword" placeholder="请输入新密码" type="password" show-password />
          <div class="password-tip">
            <ul>
              <li>长度在8-16个字符之间</li>
              <li>必须包含至少一个大写字母</li>
              <li>必须包含至少一个小写字母</li>
              <li>必须包含至少一个数字</li>
              <li>必须包含至少一个特殊字符(@$!%*?&)</li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="user.confirmPassword" placeholder="请确认密码" type="password" show-password />
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0; text-align: center;">
          <el-button type="primary" size="medium" :loading="loading" @click="submit" style="width: 180px;">
            <span v-if="!loading">保存修改</span>
            <span v-else>修改中...</span>
          </el-button>
        </el-form-item>
        <div style="text-align: center; margin-top: 15px;">
          <a href="javascript:void(0)" @click="logout" class="logout-link">
            退出登录
          </a>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getForceChangePassword, removeForceChangePassword, getForceChangePasswordReason } from "@/utils/passwordStatus";

export default {
  name: "ForceChangePasswordModal",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码长度必须在8-16个字符之间"));
      } else if (!/[a-z]/.test(value)) {
        callback(new Error("密码必须包含至少一个小写字母"));
      } else if (!/[A-Z]/.test(value)) {
        callback(new Error("密码必须包含至少一个大写字母"));
      } else if (!/\d/.test(value)) {
        callback(new Error("密码必须包含至少一个数字"));
      } else if (!/[@$!%*?&]/.test(value)) {
        callback(new Error("密码必须包含至少一个特殊字符(@$!%*?&)"));
      } else {
        callback();
      }
    };
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      loading: false,
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { validator: equalToPassword, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    alertTitle() {
      const reason = getForceChangePasswordReason();
      switch (reason) {
        case 1:
          return "您的密码强度不符合要求，为了您的账户安全，请立即修改密码！";
        case 2:
          return "您的密码已过期，请修改密码后重新登录！";
        default:
          return "为了您的账户安全，请立即修改密码！";
      }
    }
  },
  created() {
    // 检查是否需要强制修改密码
    this.checkForceChangePassword();
    // 监听路由变化，每次路由切换时都检查
    this.$router.afterEach(() => {
      this.checkForceChangePassword();
    });
  },
  methods: {
    checkForceChangePassword() {
      this.visible = getForceChangePassword();
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          // TODO: 调用修改密码接口
          // updateUserPwd(this.user.oldPassword, this.user.newPassword).then(
          //   response => {
          //     this.loading = false;
          //     // 清除强制修改密码标志
          //     removeForceChangePassword();
          //     this.visible = false;
          //     this.$message.success("密码修改成功");
          //     // 重置表单
          //     this.user = {
          //       oldPassword: undefined,
          //       newPassword: undefined,
          //       confirmPassword: undefined
          //     };
          //     this.$refs.form.resetFields();
          //   }
          // ).catch(error => {
          //   this.loading = false;
          //   this.$message.error(error.message || "密码修改失败");
          // });
          // 模拟修改成功
          setTimeout(() => {
            this.loading = false;
            removeForceChangePassword();
            this.visible = false;
            this.$message.success("密码修改成功");
            this.user = {
              oldPassword: undefined,
              newPassword: undefined,
              confirmPassword: undefined
            };
            this.$refs.form.resetFields();
          }, 1000);
        }
      });
    },
    logout() {
      // 清除所有本地存储
      localStorage.removeItem('keyToken');
      localStorage.removeItem('refreshShow');
      removeForceChangePassword();
      // 跳转到登录页面
      window.location.href = 'https://www.zgjyzjw.com';
    }
  }
};
</script>

<style scoped>
.force-change-password-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-tip {
  margin-top: 8px;
  color: #606266;
  font-size: 12px;
}

.password-tip ul {
  margin: 0;
  padding-left: 20px;
}

.password-tip li {
  line-height: 1.5;
  margin-bottom: 2px;
}

.logout-link {
  color: #409EFF;
  text-decoration: underline;
  font-size: 12px;
  text-underline-offset: 2px;
  transition: color 0.3s;
}

.logout-link:hover {
  color: #66B1FF;
  text-decoration: underline;
}
</style>